<template>
  <div class="mobile-layout">
    <Header />
    <main class="page-content-wrapper">
      <slot />
    </main>
    <MobileBottomNav />
    <!-- <PWAInstallAlert v-if="!suppressGlobalPrompts" /> -->
  </div>
</template>

<script setup>
import PWAInstallAlert from '~/components/PWAInstallAlert.vue'
import { isOrderFormRoute } from '~/utils/global-prompts.mjs'

const route = useRoute()
const suppressGlobalPrompts = computed(() => (
  route.matched.some(record => record.meta.suppressGlobalPrompts === true) ||
  isOrderFormRoute(route.path)
))

useHead({
  meta: [
    { name: 'viewport', content: 'width=device-width, initial-scale=1, maximum-scale=1' }
  ]
})
</script>

<style lang="scss" scoped>
.mobile-layout {
  min-height: 100vh;
  direction: inherit;
  
@media (max-width: 768px) {
    .page-content-wrapper {
      padding-bottom: 60px;
    }
  }
  }
</style>
